import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Switch, useLocation } from "react-router-dom";

import Sidebar from "../sidebar/Sidebar";
import { tabList } from "../../route/AppRoute";
import PageNotFound from "../../common/components/page-not-found/PageNotFound";
import UnauthorisedUser from "../../common/components/unauthorised-user/UnauthorisedUser";
import "./Dashboard.scss";
import SessionModal from "../../common/components/session-timeout/SessionModal";


const Dashboard = ({ children }) => {
  const [tabsToRender, setTabsToRender] = useState([]);

  const loader = useSelector((state) => state.loader.loader);
  const userRoles = useSelector((state) => state.profile.userRoles);

  const location = useLocation();
  const currentPath = location.pathname;

  const [validPaths, setValidPaths] = useState([]);

    /**
   * Render all routes path for validation
   */

    useEffect(() => {
      setValidPaths(getAllPaths(tabList));
    }, []);

    const getAllPaths = (routes) => {
      let paths = [];
      routes.forEach((route) => {
        if (route.child && route.child.length > 0) {
          route.child.forEach((childs) => {
            if(childs.child && childs.child.length > 0) {
              childs.child.forEach((subChilds) => {
                paths.push(subChilds.path);
              });
            }
            else {
              paths.push(childs.path);
            }
          });
        }
        else {
          paths.push(route.path);
        }
      });
      return paths;
    };

  
  /**
   * Filter tabs based on user role claim
   */
  useEffect(() => {
    if (!userRoles) {
      return;
    }
    const filteredTabs = tabList
      .filter((tab) => tab.roles.length === 0 || userRoles.some((role) => tab.roles.includes(role)))
      .filter(
        (tab, index, self) =>
          self.findIndex((v2) => v2.key === tab.key) === index
      )
      .sort((a, b) => a.key - b.key);

    const tabs = filteredTabs.map((tab) => {
      if (tab.child.length > 0) {
        tab.child = tab.child
          .filter((subTab) =>
            subTab.roles.length === 0 || userRoles.some((role) => subTab.roles.includes(role))
          )
          .filter(
            (subTab, index, self) =>
              self.findIndex((v2) => v2.key === subTab.key) === index
          )
          .sort((a, b) => a.key - b.key);
      }
      return tab;
    });

    const userTabs = tabs.map((tab) => {
      if (tab.child.length > 0) {
        tab.child.forEach((subTab) => {
          if (subTab.child.length > 0) {
            subTab.child = subTab.child
              .filter((subSubTab) =>
                subSubTab.roles.length === 0 || userRoles.some((role) => subSubTab.roles.includes(role))
              )
              .filter(
                (subSubTab, index, self) =>
                  self.findIndex((v2) => v2.key === subSubTab.key) === index
              )
              .sort((a, b) => a.key - b.key);
          }
        })
      }
      return tab;
    })
    setTabsToRender(userTabs);
  }, [userRoles]);

  /**
   * Render all routes based on tabs
   * @param {Array} tabs
   */

  const renderRoutes = (tabs) => {
    return tabs.map((tab) => {
      if (tab.child && tab.child.length > 0) {
        return renderRoutes(tab.child);
      }
      return <Route path={tab.path} component={tab.component} key={tab.key} />;
    });
  };

  return (
    <div className="dashboard-container">
      <SessionModal/>
      <Sidebar routes={tabsToRender} />
      <div className="container-fluid">
        {children}
        <Switch>
          {renderRoutes(tabsToRender)}
          {loader === 0 && (
            <Route path="*">
            {validPaths.includes(currentPath) ? (
              <UnauthorisedUser />
            ) : (
            <PageNotFound />
            )}
            </Route>
          )}
        </Switch>
      </div>
    </div>
  );
};

export default Dashboard;